"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var colors_1 = require("material-ui/styles/colors");
// import transitions from 'material-ui/styles/transitions';
var Snackbar_1 = __importDefault(require("material-ui/Snackbar"));
var done_1 = __importDefault(require("material-ui/svg-icons/action/done"));
var warning_1 = __importDefault(require("material-ui/svg-icons/alert/warning"));
var error_outline_1 = __importDefault(require("material-ui/svg-icons/alert/error-outline"));
var info_1 = __importDefault(require("material-ui/svg-icons/action/info"));
var clear_1 = __importDefault(require("material-ui/svg-icons/content/clear"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var Notifications_1 = require("./Notifications");
var getOptions = function (kind) {
    switch (kind) {
        case Notifications_1.NOTIFICATION_TYPE.SUCCESS:
            return {
                icon: react_1.default.createElement(done_1.default, { color: colors_1.white, style: { verticalAlign: 'middle' } }),
                backgroundColor: colors_1.green500,
            };
        case Notifications_1.NOTIFICATION_TYPE.DANGER:
            return {
                icon: react_1.default.createElement(warning_1.default, { color: colors_1.white, style: { verticalAlign: 'middle' } }),
                backgroundColor: colors_1.red500,
            };
        case Notifications_1.NOTIFICATION_TYPE.WARNING:
            return {
                icon: react_1.default.createElement(error_outline_1.default, { color: colors_1.white, style: { verticalAlign: 'middle' } }),
                backgroundColor: colors_1.orange300,
            };
        default:
            return {
                icon: react_1.default.createElement(info_1.default, { color: colors_1.white, style: { verticalAlign: 'middle' } }),
                backgroundColor: colors_1.blue500,
            };
    }
};
var NotificationStyled = function (_a) {
    var kind = _a.kind, id = _a.id, onDismiss = _a.onDismiss, index = _a.index, message = _a.message, position = _a.muiTheme.snackbar.position;
    var _b = getOptions(kind), icon = _b.icon, backgroundColor = _b.backgroundColor;
    return (react_1.default.createElement("div", { style: { position: 'absolute' } },
        react_1.default.createElement(Snackbar_1.default, { open: true, message: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { style: { marginRight: '10px' } }, icon),
                " ",
                message), action: react_1.default.createElement(clear_1.default, { color: "white", style: { marginLeft: '20px' } }), onActionTouchTap: function () { return onDismiss(); }, onRequestClose: function () { }, bodyStyle: {
                backgroundColor: backgroundColor,
                maxWidth: 'initial',
                transition: 'none',
                opacity: 1,
                // transition: `${transitions.easeOut('400ms', 'opacity')}`,
                // transition: ' opacity .4s ease-in',
                padding: '0px 0px 0px 24px',
            }, contentStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'flex',
                // transition: ' opacity .4s ease-in',
                // transition: `${transitions.easeOut('400ms', 'opacity')}`,
                justifyContent: 'space-between',
                opacity: 1,
                transition: 'none',
            }, style: {
                transform: 'translate(0px, 0px)',
                visibility: 'visible',
                // transition: ' visibility .1s ease-in',
                transition: 'none',
                // transition: `${transitions.easeOut('800ms', 'visibility')}`,
                right: position.right || 'auto',
                left: position.left || 'auto',
                top: position.top ? 50 * index + position.top : 'auto',
                bottom: position.bottom ? 50 * index + position.bottom : 'auto',
            } })));
};
exports.Notification = muiThemeable_1.default()(NotificationStyled);
//# sourceMappingURL=NotificationComponent.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/NotificationComponent.js
// module id = 1871
// module chunks = 0